//
//
//
//
//
//
//
//
//
//
//
//
//

import GeneralEdit from '@/components/GeneralEdit';
export default {
  name: 'Index',
  components: {
    GeneralEdit: GeneralEdit
  },
  data: function data() {
    return {
      id: this.$route.params.id,
      url: {
        getUrl: '/distributor'
      },
      rules: {
        b_distributor_code: [{
          required: true,
          message: this.$t("rules.common.required"),
          trigger: 'blur'
        }, {
          min: 0,
          max: 100,
          message: this.$t("rules.common.maxlength100"),
          trigger: 'blur'
        }],
        b_distributor_name: [{
          required: true,
          message: this.$t("rules.common.required"),
          trigger: 'blur'
        }, {
          min: 0,
          max: 100,
          message: this.$t("rules.common.maxlength100"),
          trigger: 'blur'
        }]
      }
    };
  }
};